module.exports = __webpack_public_path__ + "img/about.cdb37a43.png";